'use client';

import { FilterItem } from '@/features/listing/components/search/filters/filter-item';
import { useSearchListing } from '@/features/listing/components/search/search-provider';
export const sizesOptions = [{
  label: '30in - 32in',
  value: '12-32'
}, {
  label: '32in - 34in',
  value: '32-34'
}, {
  label: '34in - 36in',
  value: '34-36'
}, {
  label: '36in - 38in',
  value: '36-38'
}, {
  label: '38in - 40in',
  value: '38-40'
}, {
  label: '40in - 42in',
  value: '40-42'
}, {
  label: '42in - 44in',
  value: '42-44'
}, {
  label: '44in - 46in',
  value: '44-46'
}, {
  label: '46in - 48in',
  value: '46-48'
}, {
  label: '48in - 50in',
  value: '48-50'
}];
export const SizeFilter = () => {
  const {
    params,
    updateFilter
  } = useSearchListing();
  return <>
      <FilterItem label="Chest Size" options={sizesOptions || []} appliedFilters={params.chest} updateFilter={updateFilter('chest')} data-sentry-element="FilterItem" data-sentry-source-file="size-filter.tsx" />
      <FilterItem label="Waist Size" options={sizesOptions || []} appliedFilters={params.waist} updateFilter={updateFilter('waist')} data-sentry-element="FilterItem" data-sentry-source-file="size-filter.tsx" />
    </>;
};